export default {
  id: 'ClassroomPage',
  code: 'CN',
  text: {
    'Search Classroom': '搜索教室名称',
    'Sort by': '排序',
    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
    'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
    'Name: A-Z': '按名称：由A到Z',
    'Name: Z-A': '按名称：由Z到A',
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Classroom/locale.js